import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import React, { useEffect, useState } from "react";
import { ISearchPage } from "../../../types/FmsTypes";
import { transPgToPagination } from "../app/appModel";
import { IMdSupplierDetail, IMdSupplierFields, supplierService } from "./supplierService";
import { message } from "antd";
import { useGlobalModel } from "@/model/globalModel";

export const useSupplierModel = createModel(function () {
    // const { supplierLoadDataAll } = useGlobalModel(() => []);
    const initSearchParam: IMdSupplierFields = {};
    const initDataSource: IMdSupplierDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdSupplierFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdSupplierDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IMdSupplierFields>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);

    const [synchroModel, setSynchroModel] = useState<boolean>(false)
    const [syncLoading, setSyncLoading] = useState<boolean>(false);


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdSupplierFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IMdSupplierFields = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await supplierService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        clearSelectData();
    }
    const syncData = async (params?: object) => {
        let ret = await supplierService.sync({...searchParam,...params});
        ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败");
        ret && await loadData(initPgCfg, {});
        // ret && await supplierLoadDataAll();
        return ret.retData;
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        selectedData,
        synchroModel,
        syncLoading,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        syncData,
        updatePgCfg,
        setDrawerVisible,
        setSelectedData,
        setSynchroModel,
        setSyncLoading
    }
});